import React from 'react';

const ButtonFormSubmit = ({ children, onClick, disabled, size = 'lg' }) => {
    return(
        <button className={`appButton__formSubmit appButton__formSubmit--${size}`} type="submit" disabled={disabled} onClick={onClick}>
            {children}
        </button>
    )
}

export default ButtonFormSubmit;